export const ASSISTANT_TEXTS = {
	pageTitle: 'Buddy',
	connectedStatus: 'Online · Ready to help',
	senderName: 'Buddy',
	conversations: 'Conversations',
	newConversation: 'New conversation',
	inputPlaceholder: 'Ask about drivers, routes, incidents, or any operational data…',
	send: 'Send',
	viewDriverProfile: 'View Driver Profile',
	suggestedFollowUps: 'Suggested follow-ups',
	copy: 'Copy',
	editAndAsk: 'Edit & ask again',
	resend: 'Ask again',
	deleteConversation: 'Delete conversation',
	clearAllHistory: 'Clear all history',
	showMoreCrew: (n) => `Show ${n} more`,
};
